const normalize = (value) => value.normalize('NFKC').toLocaleLowerCase();

export const recentChatParticipants = (messages) => {
  const people = new Map();
  for (const message of [...messages].reverse()) {
    if (!message.user_id || !message.username || people.has(message.user_id)) continue;
    people.set(message.user_id, { id: message.user_id, username: message.username, isAdmin: !!message.is_admin });
  }
  return [...people.values()];
};

export const findMentionSuggestions = (text, selection, people) => {
  if (selection.start !== selection.end) return null;
  const caret = selection.start;
  const start = text.lastIndexOf('@', caret - 1);
  if (start < 0 || (start > 0 && /[\p{L}\p{N}_@]/u.test(text[start - 1]))) return null;
  const query = text.slice(start + 1, caret);
  if (caret <= start || /[\n\r@]/u.test(query)) return null;
  const matches = people.filter((person) => normalize(person.username).startsWith(normalize(query))).slice(0, 6);
  return matches.length ? { start, caret, query, matches, key: `${start}:${caret}:${query}:${matches.map((person) => person.id).join(',')}` } : null;
};

export const completeMention = (text, context, username) => {
  let end = context.caret;
  const remainder = username.slice(context.query.length);
  if (remainder && normalize(text.slice(end, end + remainder.length)) === normalize(remainder)) end += remainder.length;
  else while (end < text.length && /[\p{L}\p{N}_-]/u.test(text[end])) end += 1;
  const suffix = text.slice(end);
  const separator = suffix && /[\s.,!?;:)\]}]/u.test(suffix[0]) ? '' : ' ';
  const replacement = `@${username}${separator}`;
  return { text: text.slice(0, context.start) + replacement + suffix,
    caret: context.start + replacement.length + (suffix.startsWith(' ') ? 1 : 0) };
};